/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Střih`
};

const da_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Skåret`
};

const de_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `ausschneiden`
};

const en_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Cut`
};

const es_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Copa`
};

const fr_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Coupe`
};

const hu_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Vágott`
};

const it_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Taglia`
};

const nl_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Cut`
};

const pl_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `wycięcie`
};

const pt_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Corte`
};

const sv_attributes_gloves_cut = /** @type {(inputs: {}) => string} */ () => {
	return `Utskärning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_gloves_cut = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_gloves_cut(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_gloves_cut", locale)
	if (locale === "cs") return cs_attributes_gloves_cut(inputs)
	if (locale === "da") return da_attributes_gloves_cut(inputs)
	if (locale === "de") return de_attributes_gloves_cut(inputs)
	if (locale === "en") return en_attributes_gloves_cut(inputs)
	if (locale === "es") return es_attributes_gloves_cut(inputs)
	if (locale === "fr") return fr_attributes_gloves_cut(inputs)
	if (locale === "hu") return hu_attributes_gloves_cut(inputs)
	if (locale === "it") return it_attributes_gloves_cut(inputs)
	if (locale === "nl") return nl_attributes_gloves_cut(inputs)
	if (locale === "pl") return pl_attributes_gloves_cut(inputs)
	if (locale === "pt") return pt_attributes_gloves_cut(inputs)
	return sv_attributes_gloves_cut(inputs)
};
export { attributes_gloves_cut as "attributes.gloves_cut" }